import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { PageOne, PageTwo, PageThree } from './components';
;
export const DocumentSeven = memo(({ pharmacy, traderInfo, }) => (_jsxs(_Fragment, { children: [_jsx(PageOne, { pharmacy: pharmacy, traderInfo: traderInfo }), _jsx(PageTwo, { pharmacy: pharmacy, traderInfo: traderInfo }), _jsx(PageThree, { traderInfo: traderInfo })] })));
